module.exports = __webpack_public_path__ + "img/wedding-invitation.8dafed51.jpg";